module.exports = __webpack_public_path__ + "img/1551749020.91941055.jpg";